export default __webpack_public_path__ + "static/media/icon_match_test.abf92ebc.svg";